<template>
<div class="hot_spot_type no-trans" v-loading="loading">
    <div class="hot_spot_type1">
        <div class="hot_spot_type_box1">
            <div class="title_box">
                <img src="@/assets/img/login/Frame.png" alt="">
                <router-link class="span1 breadcrumb_link" style="color: inherit; text-decoration: none;" to="/home">首页</router-link> > <span class="span2">{{type_detial.title||''}}</span>
            </div>
            <div class="banner_box">
                <div class="banner_imgs">
                    <el-carousel v-if="banner_list.length">
                        <el-carousel-item v-for="(item,index) in banner_list" :key="index">
                            <div class="imgs_box" @click="handle_detial(item)">
                                <!-- <img src="../../../assets/img/index/legal/bg1.png" alt=""> -->
                                 <img :src="item.thumb" alt="">
                                <div class="img_texts">
                                    <!-- 离婚后夫妻财产如何分割 -->
                                    {{ item.title }}
                                </div>
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="banner_types">
                    <div class="types_left">
                        <div class="title_img">
                            <img src="../../../assets/img/index/home/type_gr1.png" alt="">
                            {{type_detial.title}}专区
                        </div>
                        <div class="type_const">
                            {{type_detial.description}}
                        </div>
                        <div class="type_text1"><span>{{ type_list.length }}</span>细分领域</div>
                        <div class="type_text2"><span>{{ total }}</span>+精选文章</div>
                    </div>
                    <div class="types_right">
                        <div class="teges" v-for="(item, index) in type_list" :key="index">
                            {{ item.title }}
                        </div>
                        <div class="teges2" v-for="(item, index) in 4" ></div>
                        <!-- :key="index" -->
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div class="hot_spot_type2">
        <div class="hot_spot_type_box2">
            <div class="lists_new">
                <div class="lists_box">
                    <div v-if="mobile_view && !loading && !new_list.length" class="news_empty">
                        <i class="el-icon-document" aria-hidden="true"></i>
                        <span>该分类暂无文章</span>
                    </div>
                    <div class="list_item">
                        <div class="items" :class="{ 'without-image': !item.thumb }" v-for="(item, index) in new_list" :key="index" @click="handle_detial(item)">
                            <div class="item_imgs" v-if="!mobile_view || item.thumb">
                                <!-- <img src="../../../assets/img/index/legal/bg1.png" alt=""> -->
                                 <img :src="item.thumb" alt="">
                            </div>
                            <div class="item_info">
                                <div class="info_top">
                                    <div class="item_titles">
                                        {{ item.title }}
                                    </div>
                                    <div class="item_const">
                                        {{ item.description }}
                                    </div>
                                </div>
                                <div class="info_bom">
                                    <div class="item_icons">
                                        <div class="icons">
                                            #{{ (item.category || {}).title }}
                                        </div>
                                        <div class="icons">
                                            <img src="../../../assets/img/index/comments_case/see.png" alt="">
                                            {{ item.view_num }}
                                        </div>
                                        <div class="icons">
                                            <img src="../../../assets/img/index/comments_case/time.png" alt="">
                                            {{ mobile_view ? (item.created_at || '').slice(0, 10) : item.created_at }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="pages_box" v-if="total > pages.limit">
                        <div class="btns" @click="handle_pages(1)">首页</div>
                        <site-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page="pages.page" background :page-size="pages.limit"
                            layout="prev, pager, next" :total="total">
                        </site-pagination>
                        <div class="btns" @click="handle_pages(last_page)">尾页</div>
                    </div>
                </div>
                <div class="new_box">
                    <hot_spot_new ref="hot_spot_new"></hot_spot_new>
                </div>
            </div>
        </div>
    </div>

</div>
</template>
<script>
import { useListeners } from 'vue';
import {
    mapState
} from 'vuex'

import hot_spot_new from '@/components/law/hot_spot/hot_spo_new.vue'//右边


export default {
    components: {
        hot_spot_new

    },
    name: "homes",
    data() {
        return {
            loading: false,
            total: 0,
            type_detial:{},
            type_list:[],
            new_list:[],
            last_page:0,
            pages: {
                page: 1,
                limit: 10,
            },
        }
    },
    computed: {
        banner_list(){
            let list =[]
            this.new_list.forEach((e,i)=>{
                if(i<5){
                    list.push(e)
                }
            })
            return list
        }
    },
    watch: {

    },
    created() {
        this.get_type()
        this.get_type_list()
        this.get_new_list()
    },
    methods: {
        handleSizeChange(e) {
            console.log('条数', e)
        },
        handleCurrentChange(e) {
            this.handle_pages(e)
        },
        handle_pages(i) {
            const page = Math.max(1, Math.min(i, this.last_page || 1))
            if (page === this.pages.page) return
            this.pages.page = page
            this.get_new_list()
        },
        handle_detial(item){
            this.$router.push({
                path:'/hot_spot_type_detial',
                query:{
                    id:item.id
                }
            })
        },
        get_type(){
            this.loading=true
            let parent_id=19
            if(this.$route.query.parent_id){
                parent_id=this.$route.query.parent_id
            }
            this.$api("getArticleCategoryList", {
                parent_id:parent_id,
			}, "get").then((res) => {
                this.loading = false
                console.log('分类详情',res)
                if (res.code == 1) {
                 res.data.forEach((e)=>{
                    if(e.id==this.$route.query.id){
                        console.log('e',e)
                        this.type_detial=e
                    }
                 })
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_type_list(){
            this.loading=true
            this.$api("getArticleCategoryList", {
                parent_id:this.$route.query.id,
			}, "get").then((res) => {
                this.loading = false
                console.log('分类的下级列表',res)
                if (res.code == 1) {
                    this.type_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_new_list(){
            this.loading=true
            this.$api("getArticleList", {
                category_id:this.$route.query.id,
                ...this.pages,
			}, "get").then((res) => {
                this.loading = false
                console.log('新闻列表',res)
                if (res.code == 1) {
                    this.new_list=res.data.list
                    this.total=res.data.count
                    this.last_page=Math.ceil(res.data.count/this.pages.limit)
                    
                    
                } else {
                    alertErr(res.msg)
                }
            });
        },
    },

}
</script>
<style scoped lang="less">
.hot_spot_type {
    width: 100%;

    .hot_spot_type1 {
        background-color: #F5F5F5;

        .hot_spot_type_box1 {

            width: 1440px;
            margin: auto;
            padding-top: 20px;
            padding-bottom: 40px;

            .title_box {
                padding-bottom: 21px;

                display: flex;
                align-items: center;

                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #999999;

                .span1 {
                    cursor: pointer;
                    margin-right: 10px;
                }

                .span2 {
                    cursor: pointer;
                    margin-left: 10px;
                }

                img {
                    margin-right: 10px;
                }
            }

            .banner_box {
                display: flex;
                align-items: center;

                .banner_imgs {
                    width: 420px;
                    height: 280px;
                    border-radius: 0px 0px 0px 0px;

                    /deep/.el-carousel {
                        width: 420px;
                        height: 280px;

                        .el-carousel__container {
                            width: 420px;
                            height: 280px;

                            .el-carousel__item {
                                width: 420px;
                                height: 280px;

                                .imgs_box {
                                    width: 420px;
                                    height: 280px;
                                    position: relative;
                                    cursor: pointer;

                                    img {
                                        width: 420px;
                                        height: 280px;
                                    }

                                    .img_texts {
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: bold;
                                        font-size: 18px;
                                        color: #FFFFFF;
                                        position: absolute;
                                        left: 20px;
                                        bottom: 40px;
                                        width: 400px;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        display: -webkit-box;
                                        -webkit-line-clamp:1;
                                        -webkit-box-orient: vertical;
                                    }
                                }

                            }
                        }

                        .el-carousel__indicators {
                            width: 100%;
                            justify-content: end;
                            padding: 0 20px;

                            .el-carousel__indicator {
                                .el-carousel__button {
                                    width: 10px;
                                    height: 10px;
                                    background: #FFFFFF;
                                    border-radius: 50%;
                                }
                            }

                            .is-active {
                                .el-carousel__button {
                                    width: 40px;
                                    height: 10px;
                                    background: #377CFD;
                                    border-radius: 5px 5px 5px 5px;
                                }
                            }
                        }
                    }
                }

                .banner_types {
                    width: 100%;
                    min-height: 280px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    margin-left: 24px;
                    padding: 40px;
                    display: flex;

                    // align-items: center;
                    .types_left {
                        width: 320px;
                        flex-shrink: 0;
                        border-right: 1px solid #EDEDED;

                        .title_img {
                            display: flex;
                            align-items: center;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 24px;
                            color: #333333;

                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 24px;
                            color: #333333;

                            img {
                                width: 32px;
                                height: 26px;
                                margin-right: 10px;
                            }
                        }

                        .type_const {
                            padding-top: 15px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;

                        }

                        .type_text1 {

                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                            padding-top: 40px;

                            span {
                                color: #333333;
                                font-size: 36px;
                                font-weight: bold;
                            }

                        }

                        .type_text2 {
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                            margin-top: 10px;

                            span {
                                color: #333333;
                                font-size: 36px;
                                font-weight: bold;
                            }
                        }

                    }

                    .types_right {
                        padding-left: 40px;
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        justify-content: space-between;

                        .teges {
                            width: 128px;
                            height: 36px;
                            background: #F5F5F5;
                            border-radius: 18px 18px 18px 18px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                            text-align: center;
                            line-height: 36px;
                        }

                        .teges2 {
                            width: 128px;

                        }
                    }
                }
            }

        }
    }

    .hot_spot_type2 {
        .hot_spot_type_box2 {
            width: 1440px;
            margin: auto;
            background: #FFFFFF;

            .lists_new {
                display: flex;
                // align-items: center;
                padding-top: 36px;
                background: #FFFFFF;

                .lists_box {
                    padding-right: 40px;
                    .list_item {
                        width: 984px;

                        .items {
                            margin-bottom: 32px;
                            padding-bottom: 32px;
                            border-bottom: 1px solid #EEEEEE;
                            display: flex;
                            cursor: pointer;
                            .item_imgs {
                                width: 300px;
                                height: 200px;
                                flex-shrink: 0;
                                border-radius: 0px 0px 0px 0px;

                                img {
                                    width: 300px;
                                    height: 200px;
                                }
                            }

                            .item_info {
                                padding: 10px 0;
                                padding-left: 24px;
                                height: 200px;
                                display: flex;
                                align-content: space-between;
                                flex-wrap: wrap;

                                .info_top {
                                    .item_titles {
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: bold;
                                        font-size: 18px;
                                        color: #333333;
                                    }

                                    .item_const {
                                        padding-top: 16px;
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: 400;
                                        font-size: 14px;
                                        color: #999999;

                                    }
                                }

                                .info_bom {
                                    .item_icons {
                                        display: flex;
                                        align-items: center;

                                        .icons {
                                            display: flex;
                                            align-items: center;
                                            margin-right: 24px;
                                            font-family: Microsoft YaHei, Microsoft YaHei;
                                            font-weight: 400;
                                            font-size: 14px;
                                            color: #999999;

                                            img {
                                                height: 15px;
                                                margin-right: 5px;
                                            }
                                        }
                                    }
                                }

                            }
                        }
                    }

                    .pages_box {
                        width: 100%;
                        height: 100px;
                        // background-color: red;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        /deep/.el-pagination {
                            .el-pager {
                                .number {
                                    background-color: #FFFFFF;
                                }

                                .active {
                                    background-color: #377CFD;
                                }
                            }
                        }

                        .btns {
                            width: 40px;
                            height: 32px;
                            background: #FFFFFF;
                            border-radius: 4px 4px 4px 4px;
                            border: 1px solid #EEEEEE;
                            font-family: PingFang-SC-Medium, PingFang-SC-Medium;
                            font-weight: normal;
                            font-size: 14px;
                            color: #7A7A7A;
                            text-align: center;
                            line-height: 32px;
                            cursor: pointer;
                        }
                    }
                }

                .new_box {}
            }
        }
    }

}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .hot_spot_type.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .hot_spot_type.no-trans .hot_spot_type1 .hot_spot_type_box1 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
        padding-top: 16px;
        padding-bottom: 16px;
    }
    .hot_spot_type.no-trans .hot_spot_type1 .hot_spot_type_box1 .title_box {
        padding-bottom: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
    }
    .hot_spot_type.no-trans .hot_spot_type1 .hot_spot_type_box1 .title_box .span1 {
        margin-right: 10px;
    }
    .hot_spot_type.no-trans .hot_spot_type1 .hot_spot_type_box1 .title_box .span2 {
        margin-left: 10px;
    }
    .hot_spot_type.no-trans .hot_spot_type1 .hot_spot_type_box1 .title_box img {
        margin-right: 10px;
    }
    .hot_spot_type.no-trans .hot_spot_type1 .hot_spot_type_box1 .banner_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .hot_spot_type.no-trans .hot_spot_type1 .hot_spot_type_box1 .banner_box .banner_imgs {
        max-width: 100%;
        min-width: 0;
        height: auto;
        width: 100%;
        min-height: 0;
        border-radius: 0px 0px 0px 0px;
    }
    .hot_spot_type.no-trans .hot_spot_type1 .hot_spot_type_box1 .banner_box .banner_imgs /deep/ .el-carousel {
        width: 420px;
        height: 280px;
    }
    .hot_spot_type.no-trans .hot_spot_type1 .hot_spot_type_box1 .banner_box .banner_imgs /deep/ .el-carousel .el-carousel__container {
        width: 420px;
        height: 280px;
    }
    .hot_spot_type.no-trans .hot_spot_type1 .hot_spot_type_box1 .banner_box .banner_imgs /deep/ .el-carousel .el-carousel__container .el-carousel__item {
        width: 420px;
        height: 280px;
    }
    .hot_spot_type.no-trans .hot_spot_type1 .hot_spot_type_box1 .banner_box .banner_imgs /deep/ .el-carousel .el-carousel__container .el-carousel__item .imgs_box {
        width: 420px;
        height: 280px;
    }
    .hot_spot_type.no-trans .hot_spot_type1 .hot_spot_type_box1 .banner_box .banner_imgs /deep/ .el-carousel .el-carousel__container .el-carousel__item .imgs_box img {
        width: 420px;
        height: 280px;
    }
    .hot_spot_type.no-trans .hot_spot_type1 .hot_spot_type_box1 .banner_box .banner_imgs /deep/ .el-carousel .el-carousel__container .el-carousel__item .imgs_box .img_texts {
        font-size: 18px;
        left: 16px;
        bottom: 16px;
        width: 400px;
    }
    .hot_spot_type.no-trans .hot_spot_type1 .hot_spot_type_box1 .banner_box .banner_imgs /deep/ .el-carousel .el-carousel__indicators {
        padding: 0 16px;
    }
    .hot_spot_type.no-trans .hot_spot_type1 .hot_spot_type_box1 .banner_box .banner_imgs /deep/ .el-carousel .el-carousel__indicators .el-carousel__indicator .el-carousel__button {
        width: 10px;
        height: 10px;
        border-radius: 50%;
    }
    .hot_spot_type.no-trans .hot_spot_type1 .hot_spot_type_box1 .banner_box .banner_imgs /deep/ .el-carousel .el-carousel__indicators .is-active .el-carousel__button {
        width: 40px;
        height: 10px;
        border-radius: 5px 5px 5px 5px;
    }
    .hot_spot_type.no-trans .hot_spot_type1 .hot_spot_type_box1 .banner_box .banner_types {
        min-height: 0;
        border-radius: 0px 0px 0px 0px;
        margin-left: 16px;
        padding: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .hot_spot_type.no-trans .hot_spot_type1 .hot_spot_type_box1 .banner_box .banner_types .types_left {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .hot_spot_type.no-trans .hot_spot_type1 .hot_spot_type_box1 .banner_box .banner_types .types_left .title_img {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 24px;
    }
    .hot_spot_type.no-trans .hot_spot_type1 .hot_spot_type_box1 .banner_box .banner_types .types_left .title_img img {
        width: 32px;
        height: 26px;
        margin-right: 10px;
    }
    .hot_spot_type.no-trans .hot_spot_type1 .hot_spot_type_box1 .banner_box .banner_types .types_left .type_const {
        padding-top: 15px;
        font-size: 14px;
    }
    .hot_spot_type.no-trans .hot_spot_type1 .hot_spot_type_box1 .banner_box .banner_types .types_left .type_text1 {
        font-size: 14px;
        padding-top: 16px;
    }
    .hot_spot_type.no-trans .hot_spot_type1 .hot_spot_type_box1 .banner_box .banner_types .types_left .type_text1 span {
        font-size: 24px;
    }
    .hot_spot_type.no-trans .hot_spot_type1 .hot_spot_type_box1 .banner_box .banner_types .types_left .type_text2 {
        font-size: 14px;
        margin-top: 10px;
    }
    .hot_spot_type.no-trans .hot_spot_type1 .hot_spot_type_box1 .banner_box .banner_types .types_left .type_text2 span {
        font-size: 24px;
    }
    .hot_spot_type.no-trans .hot_spot_type1 .hot_spot_type_box1 .banner_box .banner_types .types_right {
        padding-left: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .hot_spot_type.no-trans .hot_spot_type1 .hot_spot_type_box1 .banner_box .banner_types .types_right .teges {
        width: 128px;
        height: 36px;
        border-radius: 8px 8px 8px 8px;
        font-size: 14px;
        line-height: 36px;
    }
    .hot_spot_type.no-trans .hot_spot_type1 .hot_spot_type_box1 .banner_box .banner_types .types_right .teges2 {
        width: 128px;
    }
    .hot_spot_type.no-trans .hot_spot_type2 .hot_spot_type_box2 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
    }
    .hot_spot_type.no-trans .hot_spot_type2 .hot_spot_type_box2 .lists_new {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .hot_spot_type.no-trans .hot_spot_type2 .hot_spot_type_box2 .lists_new .lists_box {
        padding-right: 16px;
    }
    .hot_spot_type.no-trans .hot_spot_type2 .hot_spot_type_box2 .lists_new .lists_box .list_item {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .hot_spot_type.no-trans .hot_spot_type2 .hot_spot_type_box2 .lists_new .lists_box .list_item .items {
        margin-bottom: 16px;
        padding-bottom: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .hot_spot_type.no-trans .hot_spot_type2 .hot_spot_type_box2 .lists_new .lists_box .list_item .items .item_imgs {
        max-width: 100%;
        min-width: 0;
        height: auto;
        width: 100%;
        min-height: 0;
        border-radius: 0px 0px 0px 0px;
    }
    .hot_spot_type.no-trans .hot_spot_type2 .hot_spot_type_box2 .lists_new .lists_box .list_item .items .item_imgs img {
        max-width: 100%;
        min-width: 0;
        height: auto;
        width: 100%;
        min-height: 0;
    }
    .hot_spot_type.no-trans .hot_spot_type2 .hot_spot_type_box2 .lists_new .lists_box .list_item .items .item_info {
        padding: 10px 0;
        padding-left: 16px;
        min-height: 0;
        height: auto;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .hot_spot_type.no-trans .hot_spot_type2 .hot_spot_type_box2 .lists_new .lists_box .list_item .items .item_info .info_top .item_titles {
        font-size: 18px;
    }
    .hot_spot_type.no-trans .hot_spot_type2 .hot_spot_type_box2 .lists_new .lists_box .list_item .items .item_info .info_top .item_const {
        padding-top: 16px;
        font-size: 14px;
    }
    .hot_spot_type.no-trans .hot_spot_type2 .hot_spot_type_box2 .lists_new .lists_box .list_item .items .item_info .info_bom .item_icons {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .hot_spot_type.no-trans .hot_spot_type2 .hot_spot_type_box2 .lists_new .lists_box .list_item .items .item_info .info_bom .item_icons .icons {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-right: 16px;
        font-size: 14px;
    }
    .hot_spot_type.no-trans .hot_spot_type2 .hot_spot_type_box2 .lists_new .lists_box .list_item .items .item_info .info_bom .item_icons .icons img {
        height: 15px;
        margin-right: 5px;
    }
    .hot_spot_type.no-trans .hot_spot_type2 .hot_spot_type_box2 .lists_new .lists_box .pages_box {
        min-height: 0;
        height: auto;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .hot_spot_type.no-trans .hot_spot_type2 .hot_spot_type_box2 .lists_new .lists_box .pages_box .btns {
        width: 40px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        line-height: 1.6;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
}
@media (max-width: 1024px) {
    .hot_spot_type.no-trans {
        background: #fff;
        .news_empty { display: flex; flex-direction: column; align-items: center; gap: 12px; padding: 32px 16px; color: #87909d; font-size: 14px; }
        .news_empty i { font-size: 30px; color: #a7b8d1; }
        .hot_spot_type1 .hot_spot_type_box1 {
            padding: 12px 16px 20px;
            .title_box { padding-bottom: 12px; font-size: 13px; gap: 4px; }
            .title_box .span1, .title_box .span2 { margin: 0; }
            .banner_box {
                display: flex; flex-direction: column; gap: 16px;
                .banner_imgs {
                    width: 100%; overflow: hidden; border-radius: 4px;
                    /deep/ .el-carousel,
                    /deep/ .el-carousel .el-carousel__container,
                    /deep/ .el-carousel .el-carousel__container .el-carousel__item,
                    /deep/ .el-carousel .el-carousel__container .el-carousel__item .imgs_box {
                        width: 100%; height: auto; aspect-ratio: ~"16 / 9"; max-height: 320px;
                    }
                    /deep/ .el-carousel .el-carousel__container .el-carousel__item .imgs_box img { width: 100%; height: 100%; object-fit: cover; }
                    /deep/ .el-carousel .el-carousel__container .el-carousel__item .imgs_box .img_texts {
                        left: 0; bottom: 0; width: 100%; padding: 24px 14px 30px;
                        font-size: 16px; line-height: 25px; color: #fff;
                        background: linear-gradient(transparent, rgba(0, 0, 0, .75));
                    }
                    /deep/ .el-carousel .el-carousel__indicators { bottom: 4px; }
                    /deep/ .el-carousel .el-carousel__indicators .el-carousel__indicator .el-carousel__button { width: 6px; height: 6px; }
                    /deep/ .el-carousel .el-carousel__indicators .is-active .el-carousel__button { width: 18px; height: 6px; }
                }
                .banner_types {
                    display: block; width: 100%; height: auto; margin: 0; padding: 16px;
                    background: #f3f6fb; border-radius: 4px;
                    .types_left {
                        .title_img { font-size: 20px; line-height: 28px; gap: 8px; }
                        .title_img img { width: 24px; height: 24px; margin: 0; object-fit: contain; }
                        .type_const { padding-top: 8px; font-size: 14px; line-height: 24px; overflow-wrap: anywhere; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 3; overflow: hidden; }
                        .type_text1, .type_text2 { display: inline-block; margin: 10px 16px 0 0; padding: 0; font-size: 13px; line-height: 26px; }
                        .type_text1 span, .type_text2 span { font-size: 19px; margin-right: 4px; }
                    }
                    .types_right {
                        display: flex; width: 100%; padding: 0; margin-top: 12px; gap: 6px 12px;
                        .teges { width: auto; height: auto; padding: 0; background: transparent; font-size: 13px; line-height: 24px; color: #657a99; }
                        .teges2 { display: none; }
                    }
                }
            }
        }
        .hot_spot_type2 .hot_spot_type_box2 {
            padding: 0 16px 24px;
            .lists_new {
                display: block; padding-top: 0;
                .lists_box {
                    width: 100%; padding: 0;
                    .list_item .items {
                        display: grid; grid-template-columns: minmax(0, 1fr) 96px; gap: 14px;
                        padding: 18px 0; margin: 0; border-bottom: 1px solid #edf0f5;
                        .item_imgs { grid-column: 2; grid-row: 1; width: 96px; height: 76px; border-radius: 4px; overflow: hidden; }
                        .item_imgs img { display: block; width: 100%; height: 100%; object-fit: cover; }
                        .item_info {
                            grid-column: 1; grid-row: 1; display: block; width: 100%; padding: 0;
                            .info_top .item_titles { font-size: 16px; line-height: 25px; font-weight: 600; overflow-wrap: anywhere; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden; }
                            .info_top .item_const { padding-top: 6px; font-size: 13px; line-height: 22px; overflow-wrap: anywhere; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden; }
                            .info_bom .item_icons { gap: 4px 12px; margin-top: 10px; }
                            .info_bom .item_icons .icons { margin: 0; font-size: 13px; line-height: 22px; gap: 4px; }
                            .info_bom .item_icons .icons img { width: 13px; height: 13px; margin: 0; }
                        }
                        &.without-image { grid-template-columns: minmax(0, 1fr); }
                    }
                    .pages_box { justify-content: center; padding: 20px 0; }
                    .pages_box > .btns { display: none; }
                }
                .new_box {
                    width: 100%; margin: 24px 0 0; padding: 0;
                    /deep/ .case_new.no-trans {
                        width: 100%;
                        .r_top { width: 100%; height: auto; padding: 16px; background: #eaf1ff; }
                        .r_top .titles { font-size: 18px; line-height: 28px; }
                        .r_top .text1 { padding-top: 6px; font-size: 13px; line-height: 22px; }
                        .r_top .nums, .r_top .text2 { display: none; }
                        .r_top .btns_box { padding-top: 12px; }
                        .r_top .btns_box .btns { width: 100%; min-height: 44px; padding: 10px; font-size: 14px; line-height: 24px; }
                        .r_bom {
                            width: 100%; height: auto; margin-top: 16px; padding: 16px;
                            .el-carousel, .el-carousel__container { height: 270px; }
                            .el-carousel .el-carousel__container .banner_box {
                                padding-top: 12px;
                                .borders_box { width: 88px; height: 88px; }
                                .borders_box .borders1 { display: none; }
                                .borders_box .borders2, .borders_box .borders2 img { width: 88px; height: 88px; }
                                .ls_name { margin-top: 12px; font-size: 18px; line-height: 28px; }
                                .ls_texts { font-size: 13px; line-height: 22px; }
                                .btns_flex { padding-top: 12px; }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
